import { Toast } from '@ks/sharp-ui';
import { canBridgeUse, useBridge } from './bridge/common';

export async function toast(message) {
    if (await canBridgeUse('ui', 'showToast')) {
        const params = {
            type: 'normal',
            text: message,
        };
        const nameSpaceApi = 'ui.showToast';
        await useBridge(nameSpaceApi, params);
    } else {
        Toast.info(message);
    }
}

toast.success = async function (message) {
    if (await canBridgeUse('ui', 'showToast')) {
        const params = {
            type: 'success',
            text: message,
        };
        const nameSpaceApi = 'ui.showToast';
        await useBridge(nameSpaceApi, params);
    } else {
        Toast.success(message);
    }
};

toast.error = async function (message) {
    if (await canBridgeUse('ui', 'showToast')) {
        const params = {
            type: 'error',
            text: message,
        };
        const nameSpaceApi = 'ui.showToast';
        await useBridge(nameSpaceApi, params);
    } else {
        Toast.error(message);
    }
};
